import { createStore } from '@stencil/store';

export const MessagesStore = createStore(<{ messages: IWCChatMessage[] }>{
  messages: [],
});
